import React from 'react'
import { Carousel } from 'react-responsive-carousel'
import 'react-responsive-carousel/lib/styles/carousel.min.css'
import data from '../assets/data.json'

const Work = () => {
  return (
    <div id="work">
    <h1>WORK</h1>
      <section>
        <article>
            <Carousel
            showArrows={false}
            showIndicators={false}
            showStatus={false}
            showThumbs={false}
            infiniteLoop={true}
            interval={2000}
            autoPlay={true}
            >
                {data.projects.map((item,index)=>{
                    return(
                        <div key={index} className='workItem'>
                            <img src={item.imgSrc} alt={item.title} />
                            <aside>
                                <h1>{item.title}</h1>
                                <p>{item.description}</p>
                                <a href={item.url} target='_blank' rel="noreferrer">
                                    View More
                                </a>
                            </aside>
                        </div>
                    )
                })}
            </Carousel>
        </article>
      </section>
    </div>
  )
}

export default Work
